//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { AttrsListItem } from "@/utils/dto/objects.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "IconWithDetail",
  components: { IconView, TheMaskIcon },
  props: {
    item: {
      type: [Object, AttrsListItem],
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    objectId: {
      type: String
    },
    color: {
      type: String
    },
    bgColor: {
      type: String
    },
    bgGradientEnabled: {
      type: Boolean,
    },
    bgGradientDirection: {
      type: String
    },
    bgGradientShadowDirection: {
      type: String
    },
    mainColor: {
      type: String
    },
    adjustMainColor: {
      type: String
    },
    iconBgColor: {
      type: String
    },
    iconColor: {
      type: String
    },
    mask: {
      type: String
    },
    textColor: {
      type: [String, null],
      default: null
    },
    detail: {
      type: Boolean,
      default: false
    },
    useStorage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expand: false,
      textClamp: false
    }
  },
  computed: {
    highlight() {
      return this.$route.hash === `#${this.item.id}`
    },
    currentText() {
      return this.detail || this.expand ? this.item.fullText : this.item.shortText
    },
    imagePath() {
      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.item.image_file)
      } else {
        return `/public/object_attrs_files/${this.objectId}/${this.item.id}/`
      }
    },
    getBg() {
      if (this.bgGradientEnabled) {
        return `linear-gradient(to ${this.bgGradientDirection}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor ?? this.color}, transparent` : `${this.bgColor ?? this.color}, ${adjustColorBrightness((this.bgColor ?? this.color), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      return this.color;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handler, { passive: true })
    this.$nextTick(this.handler)
  },
  destroyed() {
    window.removeEventListener('resize', this.handler)
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    handleSelfExpand() {
      if (window.innerWidth >= 640 || this.detail || !this.textClamp) return
      this.expand = !this.expand
    },
    handler() {
      const styles = getComputedStyle(this.$refs['text'])
      const maxLines = parseInt((styles.webkitLineClamp || styles.mozLineClamp) ?? '5') + 1
      const lineHeight = parseInt(styles.lineHeight)
      this.textClamp = Boolean(this.$refs['text'].scrollHeight > maxLines * lineHeight) || this.currentText.length < this.item.fullText.length
    },
  }
}
